import React, { Fragment } from "react";
import "./user-api-key.scss";
import { ASTextField } from "../../shared/as-text-fields";
import { InputConstants } from "../../constants/input-constant";
import { Card, MenuItem, Dialog, Backdrop, Checkbox } from "@mui/material";
import { ASButton } from "../../shared/as-button/as-button";
import MessageToaster from "../../shared/message-toaster/message-toaster";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';

export default function AddNewUserAPIKeyPopup(props) {

    const { open, handleCloseDialog, formData, saveDisabled, saveNewAPIKeyHandler, handleCopyKey, generatedKey, readonly, isLoading } = props;
    return (
        <Fragment>
            <Dialog
                open={open}
                onClose={handleCloseDialog}
                handleCloseDialog={handleCloseDialog}
                BackdropComponent={Backdrop}
                BackdropProps={{
                    style: { backdropFilter: "blur(3px)" },
                    onClick: handleCloseDialog,
                }}
                PaperProps={{ sx: { borderRadius: "10px", width: "540px" } }}
                sx={{ display: 'flex', alignItems: 'start', justifyContent: 'center' }}
            >
                <Card className="user-api-input-field-box">
                    <CloseIcon
                        onClick={handleCloseDialog}
                        className="user-api-close-icon"
                    />
                    {<div className="api-key-popup-header">Generate new API Key</div>}

                    {
                        props.updateError?.length > 0 &&
                        <div className="collection-error-div">
                            <MessageToaster errorMessage={props.updateError} />
                        </div>
                    }

                    <div className="input-field-box-padding">
                        <div className="input-padding">
                            <ASTextField
                                className="text-field"
                                disabled={readonly}
                                type={InputConstants.text}
                                fullWidth
                                label="API key Name"
                                variant="outlined"
                                value={formData.name}
                                onChange={(event) => props.handleInputChange("name", event.target.value)}
                                required={true}
                            />

                        </div>

                        {readonly && generatedKey && (
                            <div>
                                <div className="warning-label">Please copy this API key now — it will no longer be visible once you close this popup.</div>
                                <div className="new-generated-key-div">
                                    <span className="new-generated-key-label">API Key:</span>
                                    <span className="new-generated-key">{generatedKey?.length > 35 ? `${generatedKey.slice(0, 35)}...` : generatedKey}</span>
                                    <ContentCopyIcon
                                        fontSize="small"
                                        titleAccess="Copy key"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            handleCopyKey(generatedKey);
                                        }}
                                        className="copy-icon"
                                    />
                                </div>
                            </div>
                        )}

                        <div className="user-api-button-flex">
                            {/* <ASButton
                                onClick={() => saveNewAPIKeyHandler()}
                                disabled={saveDisabled || readonly}
                                primary={true}
                                isPrimaryButtonUnrounded={true}
                                isTextButton={true}
                                variant={'contained'}
                            >
                                Generate
                            </ASButton> */}
                            <ASButton
                                onClick={saveNewAPIKeyHandler}
                                disabled={saveDisabled || readonly || isLoading}
                                primary={true}
                                isPrimaryButtonUnrounded={true}
                                isTextButton={true}
                                variant="contained"
                                sx={{minWidth: "101px"}}
                            >
                                {isLoading ? (
                                    <CircularProgress size={20} color="inherit" />
                                ) : (
                                    'Generate'
                                )}
                            </ASButton>
                        </div>
                    </div>
                </Card>
            </Dialog>
        </Fragment>
    );
}
